import React from 'react';
import { useHistory } from 'react-router-dom';

import { IMG_IPFS_HOST } from '../../../../config';
import utils from '../../../../utils';

function BundleCard({
  data = {},
  addToCart = () => {},
  fromPath = '/MarketHub',
  cardImageOnly = false
}) {
  const {
    title = '',
    ipfsHash = '',
    marketValue = '1',
    rarityCount = [],
    buckCount = '1',
    bundleQuantity = 0,
    bundleSupplyMinted = 0
  } = data;
  const isSold = bundleQuantity - bundleSupplyMinted <= 0;
  const history = useHistory();

  const createBundleDetailLink = () => {
    try {
      if (!data?._id) return;
      const obj = { bundleId: data._id, fromPath: fromPath };
      const cipherTextId = utils.getEncrypted(obj);
      return '/BundleDetails/' + cipherTextId;
    } catch (e) {
      return '/';
    }
  };

  return (
    <div className="Bundles-card-wrapper">
      <div className="top-section">
        <div className="details-on-card">
          <div className="text-of-details">
            <div className="bundle-title-on-card two-line-title">{title}</div>
            <div className="bundle-divider-bottom" />
            <p className="bucks-included">
              {rarityCount
                .map(
                  (rarity) =>
                    `${rarity.rarityBuckQuantity || 1} ${
                      rarity.buckRarity || 'common'
                    } buck`
                )
                .join(' + ')}
            </p>
          </div>
        </div>
        <div className="bundle-img-wrapper">
          <img
            src={
              ipfsHash
                ? IMG_IPFS_HOST + ipfsHash
                : require('../../../../img/placeholder.png')
            }
            alt=""
            className="Bundles-main-img"
          />
        </div>
        {fromPath === '/MarketHub' && (
          <div className="onhover-bundle-card-wrapper">
            <img
              src={
                require('../../../../img/svg/Actions/AlertWhite.svg').default
              }
              alt=""
              className="alert-white"
              onClick={() => history.push(createBundleDetailLink())}
            />
            <p
              className="click-for-details"
              onClick={() => history.push(createBundleDetailLink())}
            >
              Click for Bundle Detail
            </p>
          </div>
        )}
        {/* <div className="rarity-section">
          {rarityCount.some((rarity) => rarity.buckRarity === 'common') && (
            <div style={{ marginTop: -4 }} className="rarity-bg">
              <div style={{ paddingLeft: 14 }} className="text-rarity-bundle">
                <span className="rarity-img">{RARITY_ICONS.common}</span>
                &nbsp;
                <span className="rarity-text">Common</span>
              </div>
            </div>
          )}
          {rarityCount.some((rarity) => rarity.buckRarity === 'rare') && (
            <div style={{ marginTop: -24 }} className="rarity-bg">
              <div
                style={{ paddingLeft: 48, marginLeft: -14 }}
                className="text-rarity-bundle"
              >
                <span className="rarity-img">{RARITY_ICONS.rare}</span>
                &nbsp;
                <span className="rarity-text">Rare</span>
              </div>
            </div>
          )}
          {rarityCount.some(
            (rarity) => rarity.buckRarity === 'collectable'
          ) && (
            <div className="rarity-bg">
              <div className="text-rarity-bundle">
                <span className="rarity-img">
                  {RARITY_ICONS.collectable}
                </span>
                &nbsp;
                <span className="rarity-text">Collectible</span>
              </div>
            </div>
          )}
          {rarityCount.some((rarity) => rarity.buckRarity === 'ultrarare') && (
            <div style={{ marginTop: -8 }} className="rarity-bg">
              <div style={{ paddingLeft: 16 }} className="text-rarity-bundle">
                <span className="rarity-img">
                  {RARITY_ICONS.ultrarare}
                </span>
                &nbsp;
                <span className="rarity-text">Ultra&nbsp;Rare</span>
              </div>
            </div>
          )}
          {rarityCount.some((rarity) => rarity.buckRarity === 'legendary') && (
            <div style={{ marginTop: -4 }} className="rarity-bg">
              <div style={{ paddingLeft: 12 }} className="text-rarity-bundle">
                <span className="rarity-img">
                  {RARITY_ICONS.legendary}
                </span>
                &nbsp;
                <span className="rarity-text">Legendary</span>
              </div>
            </div>
          )}
        </div> */}
      </div>

      {!cardImageOnly && (
        <div className="bottom-main">
          <div className="text-section">
            <p className="bundle-price">${marketValue}</p>
            <p className="bundle-details-info">
              <span>
                <img
                  src={
                    require('../../../../img/svg/Assets/CardsBlue.svg').default
                  }
                  alt=""
                  style={{ width: '19px', height: '15px' }}
                />
              </span>
              &nbsp;{' '}
              {rarityCount.reduce(
                (prevRarityCount, currentRarity) =>
                  prevRarityCount
                    ? prevRarityCount + currentRarity.rarityBuckQuantity
                    : currentRarity.rarityBuckQuantity,
                0
              ) || buckCount}
            </p>
          </div>
          <div className="bundles-main-title two-line-title">{title}</div>
          {fromPath === '/MarketHub' ? (
            <>
              {/* className='light-green-text' */}
              <div className="bundle-quantity">
                {bundleQuantity - bundleSupplyMinted} Left
              </div>
              {isSold ? (
                <button className="button-sold-out">SOLD OUT</button>
              ) : (
                <button
                  onClick={() =>
                    addToCart(data?._id ? { ...data, type: 'bundle' } : null)
                  }
                  className="bundle-view-button"
                >
                  Add to cart
                </button>
              )}
            </>
          ) : (
            <button
              onClick={() => history.push(createBundleDetailLink())}
              className="bundle-view-button"
            >
              View Bundle
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default BundleCard;
